import { render, staticRenderFns } from "./ButtonTipoPreco.vue?vue&type=template&id=381ab666&scoped=true"
import script from "./ButtonTipoPreco.vue?vue&type=script&lang=js"
export * from "./ButtonTipoPreco.vue?vue&type=script&lang=js"
import style0 from "./ButtonTipoPreco.vue?vue&type=style&index=0&id=381ab666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ab666",
  null
  
)

export default component.exports